// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"113":"215e1b9f","378":"04ab029e","642":"96eaec00"}[chunkId] + ".css";
};